var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('permission-manager', { attrs: { "latchkey": "category.star" } }, [_c('el-tooltip', { staticClass: "item", attrs: { "effect": "dark", "content": _vm.$t('playTurbo.common.listNav.starButton'), "placement": "top", "open-delay": 600 } }, [_c('el-button', { staticClass: "star-category", class: _vm.buttonClass, attrs: { "type": "text" }, on: { "click": function click($event) {
        $event.stopPropagation();return _vm.handleClick.apply(null, arguments);
      } } }, [_c('svg-icon', { attrs: { "iconClass": _vm.icon } })], 1)], 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };